<template>
  <AutoComplete
      v-model="internalModel"
      :suggestions="filteredProducts"
      @complete="searchProduct"
      @item-select="onItemSelect"
      @clear="onItemClear"
      :forceSelection="forceSelection"
      field="name"
      :minLength=3
      placeholder="Search product by code & name ..."
  >
    <template #item="{ item, index }">
      <div class="autocomplete-row">
        <div class="autocomplete-product-code" :title="item.product_code">
          {{ item.product_code }}
        </div>
        <div class="autocomplete-name" :title="item.name">{{ item.name }}</div>
      </div>
    </template>
  </AutoComplete>
</template>

<script>
import ProductVerifiedService from "@/services/productVerifiedService";

export default {
  props: {
    value: {
      type: [Object, String],
      default: () => {
        return ""
      }
    },
    forceSelection: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    internalModel: {
      get() {
        return this.value;
      },
      set(newValue) {
        if (typeof newValue === 'string' && !this.isProductInList(newValue)) {
          const customValue = {product_id: null, name: newValue};
          this.$emit('input', customValue);
        } else {
          this.$emit('input', newValue);
        }
      }
    }
  },
  data() {
    return {
      filteredProducts: [],
    };
  },
  methods: {
    async searchProduct(event) {
      const q = (event && event.query ? String(event.query) : '').trim();
      if (q === '') return;

      try {
        const urlParams = `?searchTerm=${encodeURIComponent(q)}`;
        const response = await this.ProductVerifiedService.searchProducts(urlParams);

        const list = response && response.data ? response.data : [];
        this.filteredProducts = Array.isArray(list) ? list : [];
      } catch (error) {
        console.error('Error fetching products:', error);
        this.filteredProducts = [];
      }
    },
    isProductInList(name) {
      return this.filteredProducts.some(product => product.name === name);
    },
    onItemSelect(event) {
      this.$emit('productSelected', event);
    },
    onItemClear(event) {
      this.$emit('productCleared', event);
    },
  }
};
</script>

<style>
/* Style remains the same as it's mainly layout-related */
.autocomplete-row {
  display: flex;
  justify-content: space-between;
}

.autocomplete-name,
.autocomplete-product-code {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.autocomplete-product-code {
  width: 40%;
}

.autocomplete-name {
  width: 60%;
}

.p-autocomplete-panel {
  max-width: 100%;
  width: auto;
}

.p-autocomplete-item {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
